import { Box } from "@mui/material";

export const TableFilterIcon = (props) => {
  const { disabled, right, top, ...otherProps } = props;

  return (
    <Box
      data-testcomp="Icon_TableFilter"
      sx={{
        display: "flex",
        opacity: disabled ? 0.3 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
        right: right ? right : null,
        top: top ? top : null,
        // padding: 0 10px;
        "& svg": {
          "& g": {
            "& g": {
              transition: "all 0.5s ease-in-out",
            },
          },
        },
        "&:hover": {
          "& svg": {
            "& g": {
              "& g": {
                fill: "#ffd401",
              },
            },
          },
        },
      }}
      {...otherProps}
    >
      <Icon {...props} />
    </Box>
  );
};

const Icon = (props) => {
  const color = props?.color ? props.color : "#ADADAD";
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <g fill={color} mask="url(#b)">
          <path id="a" d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
        </g>
      </g>
    </svg>
  );
};
